// extracted by mini-css-extract-plugin
export default {"workRightTableItem":"tableRowItem_workRightTableItem__JP-7p","workRightTableItemString":"tableRowItem_workRightTableItemString__Z6AJp"};